type CookieValue = string | string[];
type CookieAdapter = {
  get: (name: string) => CookieValue | undefined;
  set: (name: string, value: CookieValue) => void;
  remove: (name: string) => void;
};

export default defineNuxtPlugin(() => {

  const cookieAdapter: CookieAdapter = {
    get: name => {

      const cookie = useCookie<CookieValue | null | undefined>(name);

      return cookie.value ?? undefined;
    
    },
    set: (name, value) => {

      const cookie = useCookie<CookieValue | null | undefined>(name);

      cookie.value = value;
    
    },
    remove: name => {

      const cookie = useCookie<CookieValue | null | undefined>(name);

      cookie.value = undefined;
    
    },
  };

  return {
    provide: {
      cookies: cookieAdapter,
    },
  };

});

declare module '#app' {
  interface NuxtApp {
    $cookies: CookieAdapter;
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $cookies: CookieAdapter;
  }
}
